import React from "react";
import { Form } from "react-bootstrap";
import { NODE_AVAILABILITY_OPTIONS } from "../../../utils/nodeAvailability";

const AvailabilityField = ({ id, value, onChange, inherited = false, isNode = false }) => (
  <Form.Group controlId={id}>
    <Form.Label>Availability</Form.Label>
    <Form.Control as="select" value={value} onChange={onChange} disabled={inherited}>
      {NODE_AVAILABILITY_OPTIONS.map((option) => (
        <option key={option.value} value={option.value}>{option.label}</option>
      ))}
    </Form.Control>
    <Form.Text className="text-muted">
      {inherited ? "Inherited from the unavailable node. New bookings and reservation QR codes are blocked." :
        isNode ? "Unavailable blocks new booking events and reservation QR codes for this node." :
        "Customer status is informational. Node availability controls booking."}
    </Form.Text>
  </Form.Group>
);

export default AvailabilityField;
